<template>
  <button
    class="pool-action-btn"
    :class="{
      active: checkedCount > 0 && !disabled,
      'is-disabled': disabled || !checkedCount,
    }"
    @click="batchRemove"
  >
    <i class="el-icon-delete" />
    {{ $l('btn_batch_remove') || '批量移除' }}
  </button>
</template>

<script>
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    batchRemove() {
      if (this.disabled || !this.checkedCount) return
      this.$emit('batch-remove')
    },
  },
}
</script>

<style scoped>
.pool-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
  white-space: nowrap;
}

.pool-action-btn i {
  font-size: 13px;
}

.pool-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.pool-action-btn.active {
  background: #fef2f2;
  border-color: #f56c6c;
  color: #f56c6c;
}

.pool-action-btn.is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pool-action-btn.is-disabled:hover {
  background: #f1f5f9;
  color: #64748b;
}
</style>
